import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSinglePricePer } from '../../../Store/PHPSlice/Sale/PricePercent';


const TableBody = ({
    id,
    dt,
    grpNm,
    firmPer,
    mrpPer,
    serialNumber,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();


    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Price Percentage Group?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSinglePricePer(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Price Percentage Group Deleted");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };





    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>{serialNumber}</TableCell>
          
                <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>{dt}</TableCell>

                <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>{grpNm}</TableCell>

                <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>{firmPer}</TableCell>

                <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>{mrpPer}</TableCell>
                <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
